












































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  Ref,
  watch,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import { useQuery } from '@vue/apollo-composable';
import axios from 'axios';

import { NOW_START_YEAR } from '@/utils';
import useAuth from '@/useAuth';
import useDelivery, { DeliveryStatus } from '@/useDelivery';
import {
  deliveryStatsMapper,
  deliveryNoteStatsMapper,
} from './dashboardMapper';

import ChartWithSelectedMonth from '@/components/Dashboard/ChartWithSelectedMonth.vue';

import incomeRange from '@/gql/managementReport/01-Income/incomeRange.gql';
import getDashboardStats from '@/gql/dashboard/getDashboardStats.gql';
import getDashboardStatsCounter from '@/gql/dashboard/getDashboardStatsCounter.gql';

import PanelStats from '@/components/PanelStats.vue';

type StatsPanelValue = {
  [key: string]: {
    weight: number;
    count: number;
    deliveryFee: number;
  };
}

const Shipping = defineComponent({
  components: {
    PanelStats,
    ChartWithSelectedMonth,
  },
  setup() {
    const { me } = useAuth();
    const NOW = useFormat.date().computerShortDate();
    const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
    const TODAY_START = useFormat.date().dayjs.set('hour', 0).set('minute', 0).set('second', 0)
      .format(DATE_TIME_FORMAT);
    const TODAY_END = useFormat.date(new Date()).dayjs.set('hour', 23).set('minute', 59).set('second', 59)
      .format(DATE_TIME_FORMAT);
    const toDecimal = (string: any, min = 0, max = 0) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: min, maximumFractionDigits: max });
    const rerender = ref(true);
    const { translate: translateShipmentStatus, shipmentStatusDashboardColorMap } = useDelivery();

    function displayDate(date: string) {
      return useFormat.date(date).displayFullThaiDate();
    }

    const yTicks = ref({ stepSize: 1 });

    const filter = reactive({
      status: undefined,
      // DUMMY
      // range: {
      //   from: useFormat.date('2021-11-20').computerShortDate(),
      //   to: useFormat.date('2021-11-20').computerShortDate(),
      // },
      isGoogleMap: false,
      range: {
        from: NOW,
        to: NOW,
      },
      now: {
        from: TODAY_START,
        to: TODAY_END,
      },
      mainSelecthub: undefined as any,
      firstCompareHub: undefined as any,
      secondCompareHub: undefined as any,
    });
    const { result: deliveryOrderStats } = useQuery(getDashboardStats, computed(() => ({
      hubId: me?.hub?.id,
      filterDeliveryLogsCreatedAtBetween: filter.now,
    })), { fetchPolicy: 'cache-and-network' });

    const statsPanel: StatsPanelValue = reactive({
      PENDING: { weight: 0, count: 0, deliveryFee: 0 },
      ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER: { weight: 0, count: 0, deliveryFee: 0 },
      PREPARE_TO_DELIVER: { weight: 0, count: 0, deliveryFee: 0 },
      ON_THE_WAY: { weight: 0, count: 0, deliveryFee: 0 },
      HUB: { weight: 0, count: 0, deliveryFee: 0 },
      // SOME_SUCCESS: { weight: 0, count: 0, deliveryFee: 0 },
      // CANCEL: { weight: 0, count: 0, deliveryFee: 0 },
    });
    const statsPanelSuccessItem: StatsPanelValue = reactive({
      SUCCESS: { weight: 0, count: 0, deliveryFee: 0 },
      NOT_SUCCESS: { weight: 0, count: 0, deliveryFee: 0 },
      // SOME_SUCCESS: { weight: 0, count: 0, deliveryFee: 0 },
      // CANCEL: { weight: 0, count: 0, deliveryFee: 0 },
    });

    const statsPanelInTransit: StatsPanelValue = reactive({
      // PENDING: { weight: 0, count: 0, deliveryFee: 0 },
      ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER: { weight: 0, count: 0, deliveryFee: 0 },
      PREPARE_TO_DELIVER: { weight: 0, count: 0, deliveryFee: 0 },
      ON_THE_WAY: { weight: 0, count: 0, deliveryFee: 0 },
      // HUB: { weight: 0, count: 0, deliveryFee: 0 },
      // SUCCESS: { weight: 0, count: 0, deliveryFee: 0 },
      // NOT_SUCCESS: { weight: 0, count: 0, deliveryFee: 0 },
      // SOME_SUCCESS: { weight: 0, count: 0, deliveryFee: 0 },
      // CANCEL: { weight: 0, count: 0, deliveryFee: 0 },
    });

    const summationStats = reactive({
      PENDING: 0,
      IN_PROGRESS: 0,
      SUCCESS: 0,
      NOT_SUCCESS: 0,
    });

    watch(() => deliveryOrderStats.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        summationStats.PENDING = 0;
        summationStats.IN_PROGRESS = 0;
        summationStats.SUCCESS = 0;
        summationStats.NOT_SUCCESS = 0;

        deliveryOrderStats.value.dashboardStats.count.forEach((item: any) => {
          if (statsPanelInTransit[item.status]) {
            statsPanelInTransit[item.status].weight = 0;
            statsPanelInTransit[item.status].count = 0;
            statsPanelInTransit[item.status].deliveryFee = 0;
          } else if (statsPanel[item.status]) {
            statsPanel[item.status].weight = 0;
            statsPanel[item.status].count = 0;
            statsPanel[item.status].deliveryFee = 0;
          }
        });

        // FIXME: Refactor please. me in the future.
        statsPanelSuccessItem.SUCCESS.weight = 0;
        statsPanelSuccessItem.SUCCESS.count = 0;
        statsPanelSuccessItem.SUCCESS.deliveryFee = 0;
        statsPanelSuccessItem.NOT_SUCCESS.weight = 0;
        statsPanelSuccessItem.NOT_SUCCESS.count = 0;
        statsPanelSuccessItem.NOT_SUCCESS.deliveryFee = 0;
        // eslint-disable-next-line
        deliveryOrderStats.value.separateDashboardStats?.count.forEach((item: any) => {
          if (statsPanelSuccessItem[item.status]) {
            statsPanelSuccessItem[item.status].weight += item.weight;
            statsPanelSuccessItem[item.status].count += item.count;
            statsPanelSuccessItem[item.status].deliveryFee += item.deliveryFee;
          }
        });

        Object.keys(statsPanel).forEach((statusKey: string) => {
          deliveryOrderStats.value.dashboardStats.count.forEach((item: any) => {
            if (item.status === statusKey) {
              if (statsPanelInTransit[statusKey] && (item.inTransit === 'IN' || item.inTransit === 'OUT')) {
                statsPanelInTransit[statusKey].weight += item.weight;
                statsPanelInTransit[statusKey].count += item.count;
                statsPanelInTransit[statusKey].deliveryFee += item.deliveryFee;
              } else if (statsPanel[statusKey]) {
                statsPanel[statusKey].weight += item.weight;
                statsPanel[statusKey].count += item.count;
                statsPanel[statusKey].deliveryFee += item.deliveryFee;
              }

              if (statusKey === 'PENDING') summationStats.PENDING += item.count;
              else if (statusKey === 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER'
                || statusKey === 'PREPARE_TO_DELIVER'
                || statusKey === 'ON_THE_WAY'
                || statusKey === 'HUB') summationStats.IN_PROGRESS += item.count;
              else if (item.status === 'SUCCESS') summationStats.SUCCESS += item.count;
              else if (item.status === 'NOT_SUCCESS') summationStats.NOT_SUCCESS += item.count;
            }

            if (statusKey === 'PENDING' && item.status === 'WAITING_TO_CONFIRM') {
              statsPanel.PENDING.weight += item.weight;
              statsPanel.PENDING.count += item.count;
              statsPanel.PENDING.deliveryFee += item.deliveryFee;

              summationStats.PENDING += item.count;
            }
          });
        });
      }
    });

    return {
      me,
      toDecimal,
      NOW,
      useFormat,
      filter,
      yTicks,
      displayDate,
      translateShipmentStatus,
      shipmentStatusDashboardColorMap,
      rerender,
      incomeRange,
      getDashboardStats,
      getDashboardStatsCounter,

      statsPanel,
      statsPanelInTransit,
      statsPanelSuccessItem,
      summationStats,
    };
  },
});

export default Shipping;
